var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChecklistForms = function SvgChecklistForms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.962 3.112c-.367.042-.86.086-1.223.13q-.516.062-1.024.121c-.708.082-1.27.637-1.322 1.335a86 86 0 0 0 0 13.115 1.434 1.434 0 0 0 1.325 1.313c4.315.346 8.25.346 12.565 0a1.434 1.434 0 0 0 1.325-1.313c.335-4.455.335-8.66 0-13.115-.052-.698-.614-1.253-1.323-1.335l-1.024-.121c-.362-.044-.868-.088-1.236-.13"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.864.879c1.398.053 2.18.748 2.18 1.948s-.782 1.896-2.18 1.95c-2.262.085-1.465.085-3.727 0-1.398-.054-2.18-.75-2.18-1.95S5.739.932 7.137.88C9.4.792 8.602.792 10.864.879M5.617 9.4h6.767M5.617 13.194H9.7"
  }))));
};
export default SvgChecklistForms;